<Loader :loading="loading" />


<!-- Modal for editing document approval -->
<div class="modal fade" id="edit_document_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit document approval</h5>
        <button type="button" class="btn-close  text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="edit_document_data">
        <div class="modal-body">
          <div class="mb-3">
            <label for="name" class="form-label text-xs fw-500">Document Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-5 text-xs" id="document_name"value="document_name" placeholder="Enter document name"
              v-model="document_name">
            <p v-if="errors.edit_document_name" class="text-danger text-xs">{{ errors.edit_document_name }}</p>
          </div>
          <QuillEditor theme="snow"
          v-model="document_description"
          ref="quillDocumentEditorRef"
          class="quill-editor"
          toolbar="full" />
          <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
            <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
              <label for="editdocumentFileInput" class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                <i class='bx bx-image-add file-upload-icon'></i> Add Feed content
              </label>
              <input type="file" id="editdocumentFileInput" class="file-input d-none" @change="handleEditFileUpload"/>
              <div v-if="editFileName" class="text-xs text-secondary fst-italic mt-1">
                <span class="fw-500">File name:</span> {{ editFileName }}
              </div>
              <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>
            </div>
          </div>
          <div class="d-flex flex-column" v-if="edit_documents.document_approval_files && edit_documents.document_approval_files.length">
            <div class="row g-3">
              <div v-for="(fileObj, index) in edit_documents.document_approval_files" :key="index" class="col-4 position-relative mb-3">

                  <!-- Image -->
                  <img v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                       :src="fileObj.file.file_url"
                       alt="Feed Image"
                       class="img-fluid rounded-5 w-100 h-50"
                       :class="{ 'zoomed-in': isZoomed }"
                       @click="display_comment_modal(report)"
                       ref="image" />

                  <!-- Audio -->
                  <audio v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                         controls
                         class="w-100 rounded-5">
                    <source :src="fileObj.file.file_url" type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>

                  <!-- Video -->
                  <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls
                         class="img-fluid rounded-5 w-100">
                    <source :src="fileObj.file.file_url" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>

                  <!-- PDF -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.pdf')"
                          :src="'https://docs.google.com/viewer?url=' + encodeURIComponent(fileObj.file.file_url) + '&embedded=true'"
                          frameborder="0" width="100%" height="500px">
                  </iframe>

                  <!-- Word Document -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.docx') || fileObj.file.file_url.includes('.doc')"
                          :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                          class="img-fluid rounded-5 w-100">
                  </iframe>

                  <!-- Excel Document -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.xls') ||
                                      fileObj.file.file_url.includes('.xlsx') ||
                                      fileObj.file.file_url.includes('.xlsm') ||
                                      fileObj.file.file_url.includes('.xlsb')"
                          :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                          frameborder="0" width="100%" height="500px">
                  </iframe>

                  <!-- Zoom Button -->
                  <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')"
                          @click="toggleZoom"
                          class="zoom-btn btn btn-light position-absolute top-0 end-0 m-2 bg-transparent rounded-5">
                    <i :class="isZoomed ? 'bx bxs-zoom-out fs-5 text-white' : 'bx bxs-zoom-in fs-5 text-white'"></i>
                  </button>

                  <!-- Fullscreen Button -->
                  <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')"
                          @click="toggleFullscreen"
                          class="fullscreen-btn position-absolute btn btn-light top-0 start-0 m-2">
                    <i class="bi bi-arrows-fullscreen"></i>
                  </button>

                </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Post</button>
        </div>
      </form>
          </div>
    </div>
</div>

<CreateDocumentApproval @new_document="add_document_approval" @new_temp_post="add_temporary_post"/>
<div class="d-flex align-items-center temporary-post" v-if="temporary_post" id="temp-post">
  <p class="text-xs fw-bold">{{ temporary_post.document_name }} - Posting...</p>
  <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
</div>
<div v-if="document_approvals.length">
  <div
    v-for="document in document_approvals"
    :key="document.id"
    class="card shadow card-hover bg-white border-0 mb-4 report-card p-3 rounded-5 d-flex flex-column full-width-mobile"
  >
    <div class="row flex-grow-1">
      <div class="col">
        <div class="d-flex flex-start">
          <div class="flex-grow-1 flex-shrink-1">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Document name and date -->
              <div>
                <h5 class="fw-500 text-xs mb-1 fw-bold">{{ document.name }}</h5>
                <span class="text-muted small">{{ form_date(document.date_created) }}</span>
              </div>
              <div class="dropstart" @click.stop v-if="String(document.creater.id) === String(user_id)">
                <a href="#" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown">
                  <i class="bi bi-three-dots-vertical"></i>
                </a>
                <ul class="dropdown-menu custom-dropdown">
                  <li v-if="user_details.user_role === 'admin' || portal_admin" class="dropdown-item text-xs border-bottom fw-bold" @click.prevent="togglePinDocument(document)">
                    <i :class="document.is_pinned ? 'bx bx-pin' : 'bx bxs-pin'"></i>
                    {{ document.is_pinned ? 'Unpin' : 'Pin' }}
                  </li>
                  <li v-if="['pending', 'rejected', 'request_changes'].includes(document.status.name)">
                    <a class="dropdown-item text-xs fw-bold" href="#" data-bs-toggle="modal" data-bs-target="#edit_document_modal"
                      @click="edit_document(document)">
                      <i class="bx bxs-edit"></i> Edit
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item text-xs fw-bold" href="#" @click.prevent="deleteDocument(document.id)">
                      <i class='bx bxs-trash-alt'></i> Delete
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="text-xs display-6 mt-3" v-html="document.description"></div>

        <div v-if="document.document_approval_files.length" class="d-flex flex-column mt-3">
          <div v-for="(fileObj, index) in document.document_approval_files" :key="index" class="mb-3">
            <!-- PDF -->
            <div class="uploaded-file" @click="previewDocument(fileObj)">
              <img :src="getFileIcon(fileObj.file.file_url)" class="file-icon small-icon" />
              <span class="file-name">{{ getFileName(fileObj.file.file_url) }}</span>
              <a :href="fileObj.file.file_url" download :title="getFileName(fileObj.file.file_url)" class="download-btn" @click.stop>
                <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon" />
              </a>
            </div>
          </div>
        </div>
        <div v-if="document.reviewer.length > 0" class="mt-4">
          <div class="card">
            <div class="card-header bg-white">
              <h5 class="mb-0">Approval Chain</h5>
            </div>
            <div class="card-body">
              <!-- Approval Chain Visualization -->
              <div class="d-flex justify-content-center align-items-center flex-wrap">
                <div v-for="(approver, index) in document.reviewer" :key="approver.id">
                  <!-- Approver Circle -->
                  <div class="text-center mx-2">
                    <div
  class="rounded-circle d-flex justify-content-center align-items-center reviewer-circle"
 :class="{
              'bg-success': approver.status === 'approved',
              'bg-danger': approver.status === 'rejected',
              'bg-warning': approver.status === 'request_changes',
              'bg-secondary': approver.status === 'pending' || !approver.status
            }"
>
  <span class="text-white fw-bold">
    {{ approver.first_name.charAt(0).toUpperCase() }}
  </span>
</div>


                    <p class="mt-2 mb-0 fw-medium">{{ approver.first_name }}</p>
                  </div>

                  <!-- Line Connector -->
                  <div v-if="index < document.reviewer.length - 1" class="mx-2"></div>
                </div>
              </div>

              <!-- Request Changes Box -->
              <div v-if="['request_changes', 'rejected'].includes(document.status.name)" class="mt-4">
                <label class="fw-medium mb-2">
                  {{ document.status.name === 'request_changes' ? 'Changes Requested:' : 'Reason for Rejection:' }}
                </label>

                <div class="d-flex">
                  <div class="flex-grow-1 border p-2 rounded bg-light">
                    <div v-for="reviewer in document.reviewer" :key="reviewer.id" class="mb-2">
                      <strong>{{ reviewer.first_name }} {{reviewer.last_name}}</strong>:
                      <span>{{ reviewer.comment || reviewer.review_comment || 'No comment provided.' }}</span>
                    </div>
                  </div>
                </div>
              </div>



              <!-- Action Buttons --><div v-if="is_reviewer(document) && document.status.name === 'pending'" class="row mb-4 mt-4">
  <template v-if="is_next_reviewer(document)">
    <!-- ✅ Show buttons to next pending reviewer -->
    <div class="col-md-4 mb-2 mb-md-0">
      <button class="btn btn-success w-75" @click="approve_document(document.id)">Approve</button>
    </div>
    <div class="col-md-4 mb-2 mb-md-0">
      <button class="btn btn-warning w-75 text-white" @click="requestChanges(document.id)">Request Changes</button>
    </div>
    <div class="col-md-4 mb-2 mb-md-0">
      <button class="btn btn-danger w-75" @click="reject_document(document.id)">Reject</button>
    </div>
  </template>

  <!-- 🔒 Show message to other reviewers -->
  <div v-else class="alert alert-info w-100 mt-2">
    Waiting for previous reviewers to complete their review.
  </div>
</div>




            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
<div v-else class="text-center">No available document approvals</div>

<!-- Document Preview Modal -->
<div class="modal fade" id="document_preview_modal" tabindex="-1" aria-labelledby="documentPreviewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="documentPreviewModalLabel">Document Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Dynamically display document content -->
        <div v-if="previewDocumentType === 'pdf'">
          <embed :src="previewDocumentUrl" type="application/pdf" width="100%" height="600px">
        </div>
        <div v-else-if="previewDocumentType === 'word'">
          <!-- Word document viewer -->
          <iframe :src="previewDocumentUrl" width="100%" height="600px"></iframe>
        </div>
        <div v-else-if="previewDocumentType === 'excel'">
          <!-- Excel document viewer -->
          <iframe :src="previewDocumentUrl" width="100%" height="600px"></iframe>
        </div>

        <div v-else-if="previewDocumentType === 'image'">
          <img :src="previewDocumentUrl" class="img-fluid" alt="Document Image">
        </div>

        <div v-else>
          <p class="text-center">No preview available for this document type.</p>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


